import { convertToQueryString } from '@core/queryString'

const GTM_NAMESPACE = 'dataLayer'
const GTM_TAG_ID = 'gtm-tag'

const getGTMSourceUrl = ({
  containerId,
  envName,
  authToken,
}: {
  containerId: string
  envName: string
  authToken: string
}) => {
  // We can configure GTM test environments via URL params.
  // If ID and token are not defined, GTM uses the live environment by default.
  // See: https://support.google.com/tagmanager/answer/6311518?hl=en
  const urlParams = {
    id: containerId,
    // eslint-disable-next-line camelcase
    gtm_preview: envName,
    // eslint-disable-next-line camelcase
    gtm_auth: authToken,
    // eslint-disable-next-line camelcase
    gtm_cookies_win: envName ? 'x' : undefined,
  }

  return `https://www.googletagmanager.com/gtm.js?${convertToQueryString(
    urlParams
  )}`
}

export const GTMScript = ({
  nonce,
  containerId,
  envName,
  authToken,
}: {
  nonce?: string
  containerId: string
  envName: string
  authToken: string
}) => {
  const src = getGTMSourceUrl({
    containerId,
    envName,
    authToken,
  })

  return (
    <>
      <script
        async
        src={src}
        id={GTM_TAG_ID}
        nonce={nonce}
        data-nonce={nonce}
      />
      <script
        nonce={nonce}
        dangerouslySetInnerHTML={{
          __html: `(function(namespace) {
                        window[namespace] = window[namespace] || []
                        window[namespace].push({
                          'gtm.start': new Date().getTime(),
                          event: 'gtm.js',
                        })

                      })('${GTM_NAMESPACE}')`,
        }}
      />
    </>
  )
}
